module.exports = __webpack_public_path__ + "static/img/class_31.8e987252.jpg";